import { Box, Typography, Chip, Tooltip, useTheme, Grid, Card } from '@material-ui/core'
import { components, constants, useServices, useTranslation, useWhiteLabelServiceSettings } from 'cng-web-lib'
import moment from 'moment-timezone'
import { useParams } from 'react-router-dom'
import AciHighwayManifestApiUrls from 'src/apiUrls/AciHighwayManifestApiUrls'
import AciHighwayCargoApiUrls from 'src/apiUrls/AciHighwayCargoApiUrls'
import NaCodeMaintenanceApiURLs from 'src/apiUrls/NaCodeMaintenanceApiUrls'
import React, { useEffect, useRef, useState } from 'react'
import Namespace from 'src/constants/locale/Namespace'
import Table from '../../../components/aciacehighway/Table'
import TinyChip from '../../../components/aciacehighway/TinyChip'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import pathMap from 'src/paths/pathMap'
import ConfirmDialogShowProgress from 'src/views/common/ConfirmDialogShowProgress'
import ConfirmDialog from 'src/views/common/ConfirmDialog'
import NoteFlagDialog from 'src/views/acihighway/manifest/NoteFlagDialog'
import { format } from 'date-fns'
import { getStatusMetadata } from '../../../common/NACommon'
import axios from 'axios'
import { FileForUserGetPartyId, FileForUserGetUserDetails, GetLoggedInUserPartyName } from 'src/common/FileForUserCommon'
import EmailCoverSheetDialog from 'src/views/acihighway/manifest/EmailCoverSheetDialog'
import FaxCoverSheetDialog from 'src/views/acihighway/manifest/FaxCoverSheetDialog'
import TemplateSelectDialogWithOptionACIHWY from 'src/components/aciacehighway/TemplateSelectDialogWithOptionACIHWY'
import CngSection from 'src/components/cngcomponents/CngSection'
import CargoTable from './view/CargoTable'
import sweetalert from 'sweetalert'
import ResponseLog from './view/ResponseLog'
import { fetchUser } from "src/views/userprofile/UserProfileService.js";
import ChargeTypeDialog from '../../common/ChargeTypeDialog'
import ACIHighwayManifestTranslationText from './../contexts/ACIHighwayManifestTranslationText'

const {
  button: { CngButton },
  table: { useFetchCodeMaintenanceLookup },
  CngDialog
} = components

const { filter: { BETWEEN, EQUAL, IN, LIKE } } = constants

const dataD4 = {
  "moduleName": "",
  "noticeType": "",
  "cbsaRefNo": "",
  "msgFunctionCode": "",
  "cbsaProcessDateTime": "",
  "noticeReasonCode": "",
  "remarks": "",
  "documentType": "",
  "documentNumber": "",
  "responseId": "",
  "partyId": 0
}

function TablePage(props) {
  const { history, location, manifestId, showNotification } = props
  const { id } = useParams()
  const { state } = location
  const { createRecord, deleteRecord, fetchRecords, securedSendRequest } = useServices()
  const tableRef = useRef(null)
  const fetchCodeMaintenanceLookup = useFetchCodeMaintenanceLookup()
  const whiteLabelServiceSettings = useWhiteLabelServiceSettings("aci-highway")

  const [lookups, setLookups] = useState(null)
  const [manifestTemplateDialog, setManifestTemplateDialog] = useState(false)
  const [confirmDialog, setConfirmDialog] = useState({ open: false, manifest: null })
  const [noteFlagDialog, setNoteFlagDialog] = useState({ open: false, manifest: null })
  const [quickGlanceShipmentDialog, setQuickGlanceShipmentDialog] = useState({ open: false, manifest: null })
  const [quickGlanceResponseLogDialog, setQuickGlanceResponseLogDialog] = useState({ open: false, manifest: null })
  const [emailCoverSheetDialog, setEmailCoverSheetDialog] = useState({ open: false, data: null })
  const [faxCoverSheetDialog, setFaxCoverSheetDialog] = useState({ open: false, data: null })

  const theme = useTheme()
  const [massDeleteConfirmDialog, setMassDeleteConfirmDialog] = useState({ open: false, idList: null })

  const [chargeTypes, setChargeTypes] = useState([])
  const [submitDialog, setSubmitDialog] = useState({ open: false, items: [] })

  const [isSuperParty, setSuperParty] = useState(false);
  const [loading, setLoading] = useState(false);

  const [user, setUser] = useState([]);

  const aciHighwayManifestTranslationText = ACIHighwayManifestTranslationText()

  useEffect(() => {
    let fileForUserDetails = FileForUserGetUserDetails();
    fetchUser(setUser, securedSendRequest, fileForUserDetails);
  }, []);

  useEffect(() => {
    Promise.all([
      // Status
      fetchCodeMaintenanceLookup(
        constants.CodeMaintenanceType.CODE_MASTER,
        undefined,
        [{ field: 'codeType', operator: EQUAL, value: 'ACIHWY_STATUS' }],
        undefined,
        'code'
      ),
      // Expected Time Zone
      fetchCodeMaintenanceLookup(
        constants.CodeMaintenanceType.CODE_MASTER,
        undefined,
        [{ field: 'codeType', operator: EQUAL, value: 'SCHEDULER_TIME_ZONE' }],
        undefined,
        'code'
      ),
      // First expected port
      fetchRecords.execute(
        NaCodeMaintenanceApiURLs.GET,
        {
          filters: [
            { field: 'indicator', operator: EQUAL, value: 'ACI' }
          ],
          customData: { codeMType: 'CustomsOffice' }
        },
        (res) => {
          const result = {}

          res.content.forEach((item) => {
            result[item.code] = item.descriptionEn
          })

          return result
        }
      ),
      // Charge type
      fetchCodeMaintenanceLookup(
        constants.CodeMaintenanceType.CODE_MASTER,
        undefined,
        [{ field: 'codeType', operator: EQUAL, value: 'BILLING_CHARGE_TYPE' }],
        undefined,
        'code'
      ),
      // Super party
      fetchCodeMaintenanceLookup(
        constants.CodeMaintenanceType.CODE_MASTER,
        undefined,
        [{ field: 'codeType', operator: EQUAL, value: 'BILLING_SUPER_PARTY' }],
        undefined, 'code'
      )
    ]).then(([status, timeZone, firstExpectedPort, billingChargeTypes, billingSuperParty]) => {
      setLookups({ status, timeZone, firstExpectedPort })

      compileChargeTypes(billingChargeTypes)

      Object.keys(billingSuperParty).forEach(e => {
        if (e == GetLoggedInUserPartyName()) {
          setSuperParty(true);
        }
      })
    })
  }, [])

  function compileChargeTypes(billingChargeTypes) {
    var jsonArray = [];
    if (billingChargeTypes) {
      Object.entries(billingChargeTypes).forEach((e) => {
        var jsonObject = { code: e[0], desc: e[1] }
        jsonArray.push(jsonObject)
      })
    }
    setChargeTypes(jsonArray)
  }

  function getDriverName(data) {
    var fullName = '';
    for (let d in data.personDTO) {
      var row = data.personDTO[d]
      if (row.role === 'EJ') {
        fullName = row.firstName + ' ' + row.lastName
      }
    }
    return fullName;
  }

  function getCargoCount(data) {
    var count = 0;
    for (let d in data.cargoDTO) {
      count++;
    }
    return count;
  }

  function getCargoCountStyle(data) {
    var green = true;
    for (let d in data.cargoDTO) {
      var row = data.cargoDTO[d];
      if (!row.entryNo && row.cargoType != "IN-BOND") {
        green = false;
      }
    }

    if (data.status == 1001 || data.status == 1005) {
      return getStatusMetadata(data.status);
    } else if (green) {
      return { color: '#008000' }
    }
    return { color: '#DF2901' }
  }

  const { translate } = useTranslation([
    Namespace.UI_COMPONENT,
    Namespace.ACIHWY_MANIFEST,
    Namespace.COMMON_VALIDATION_MESSAGE
  ])

  function getLookupValue(name, value) {
    if (!lookups) return value

    return lookups[name] && lookups[name][value] ? lookups[name][value] : value
  }

  let columns = [
    {
      field: 'noteContentExist',
      title: aciHighwayManifestTranslationText.noteFlag,
      render: (data) => {
        let content = [
          <Tooltip key='more' title={data.reminderNote} placement='top'>
            <Chip
              clickable
              onClick={(event) => {
                event.stopPropagation()
                setNoteFlagDialog({ open: true, manifest: data })
              }}
              icon={<FontAwesomeIcon fixedWidth icon={['fas', 'flag']} style={data.noteContentExist ? { color: 'red' } : null} />}
              size='small'
              style={{ fontSize: 12, backgroundColor: 'transparent' }}
            />
          </Tooltip>
        ]

        return (
          <Box display='flex' flexDirection='row' flexWrap='wrap' style={{ gap: 4 }}>{content}</Box>
        )
      }
    },
    {
      field: 'tripNum',
      sortKey: 'tripNum',
      title: `${aciHighwayManifestTranslationText.tripNum} / ${aciHighwayManifestTranslationText.scac}`,
      render: (data) => (
        <Box>
          <Typography component='div' variant='inherit' style={{ marginBottom: 4 }}>
            {data.tripNum}
          </Typography>
          <Typography color='textSecondary' style={{ fontSize: 12, lineHeight: 1.2 }}>
            {data.carrierCode}
          </Typography>
        </Box>
      )
    },
    {
      field: 'expArrivalDate',
      sortKey: 'expArrivalDate',
      title: aciHighwayManifestTranslationText.expArrivalDate,
      render: (data) =>
        data.expArrivalDate && moment(data.expArrivalDate).format('D MMM YYYY, HH:mm')
    },
    {
      field: 'status',
      sortKey: 'status',
      title: aciHighwayManifestTranslationText.status,
      render: (data) => {
        const status = getStatusMetadata(data.status)

        return (
          <>
            <Tooltip key='more' title={aciHighwayManifestTranslationText.viewResponse} placement='top'>
              <Chip
                label={status.label}
                size='small'
                style={{
                  backgroundColor: status.color,
                  color: status.contrastColor
                }}
                clickable
                onClick={(event) => {
                  event.stopPropagation()
                  setQuickGlanceResponseLogDialog({ open: true, manifest: data })
                }}
              />
            </Tooltip>
            <Typography color='textSecondary' style={{ fontSize: 12, lineHeight: 1.2 }}>
              {data.responseDateTime && moment(data.responseDateTime).tz("Canada/Eastern").format('D MMM YYYY, HH:mm')}
            </Typography>
          </>
        )
      }
    },
    {
      title: `${aciHighwayManifestTranslationText.cargoStatus} & ${aciHighwayManifestTranslationText.ccn}`,
      field: 'firstCargoInfo',
      render: (data) => {
        let firstCargoInfo = data.firstCargoInfo

        if (!firstCargoInfo) return

        let firstCargoInfoSplit = firstCargoInfo.split("|")
        let firstCargoInfoStatus = firstCargoInfoSplit[0]
        let firstCargoInfoSCN = firstCargoInfoSplit[1]
        let statusIndicator = {
          backgroundColor: "#008000",
          color: "#ffffff"
        };

        if (data.status == '1001' || data.portMismatch > 0 || data.rejectedCargo > 0) {
          statusIndicator.backgroundColor = "#DF2901";
        } else if (data.awaitingEntryNo > 0) {
          statusIndicator.backgroundColor = "#ffc400";
          statusIndicator.color = "#121212"
        }

        const status = getStatusMetadata(firstCargoInfoStatus)
        if (status.label == 'Accepted') {
          status.color = statusIndicator.backgroundColor;
          status.contrastColor = statusIndicator.color;
        }

        let content = [
          <Chip
            key='first'
            label={[status.label, firstCargoInfoSCN].join(' | ')}
            size='small'
            style={{
              color: status.contrastColor,
              backgroundColor: status.color,
              fontSize: 12
            }}
          />
        ]

        if (data.portMismatch && data.portMismatch > 0) {
          content.push(
            <Chip key='first' label={aciHighwayManifestTranslationText.portMismatch} size='small'
              style={{
                color: '#ffffff',
                backgroundColor: '#DF2901',
                fontSize: 12
              }}
            />
          )
        }

        function renderButton() {
          const otherCargoInfo = data.noOfCargo - 1;

          return (
            <Tooltip key='more' title={aciHighwayManifestTranslationText.quickGlanceAtCargo} placement='top'>
              <Chip
                label={otherCargoInfo > 0 ? `${otherCargoInfo} more` : 'view'}
                clickable
                onClick={(event) => {
                  event.stopPropagation()
                  setQuickGlanceShipmentDialog({ open: true, manifest: data })
                }}
                icon={<FontAwesomeIcon fixedWidth icon={['fal', 'eye']} />}
                size='small'
                style={{ fontSize: 12 }}
              />
            </Tooltip>
          )
        }

        return (
          <>
            <Box display='flex' flexDirection='row' flexWrap='wrap' style={{ gap: 4 }}>
              {content}
            </Box>
            {(data.noOfCargo && data.noOfCargo > 0) && (
              <Box mt={0.5}>
                {renderButton()}
              </Box>
            )}
          </>
        )
      }
    },
    {
      field: "fullName",
      sortKey: 'fullName',
      title: aciHighwayManifestTranslationText.driver,
      //render: (data) => getDriverName(data)
    },
    {
      field: "conveyanceNum",
      sortKey: 'conveyanceNum',
      title: aciHighwayManifestTranslationText.truck,
    },
    {
      field: "equipmentNo",
      sortKey: 'equipmentNo',
      title: aciHighwayManifestTranslationText.trailer,
      //render: (data) => (undefined !== data.trailerDTO[0] ? data.trailerDTO[0].equipmentNumber : '')
    },
    // {
    //   field: "cargoCount",
    //   title: aciHighwayManifestTranslationText.cargoCount,
    //   render: (data) => {
    //     const style = getCargoCountStyle(data);

    //     return (
    //       <Typography variant='inherit' style={{ color: style.color }}>
    //         {getCargoCount(data)}
    //       </Typography>
    //     )
    //   }
    // },
    {
      field: 'firstExpectedPort',
      sortKey: 'firstExpectedPort',
      title: aciHighwayManifestTranslationText.firstExpectedPort,
      render: (data) =>
        <Typography component='div' variant='inherit'>
          {getLookupValue('firstExpectedPort', data.firstExpectedPort)}
          <TinyChip label={data.firstExpectedPort} variant='outlined' />
        </Typography>
    },
    {
      field: 'createdDate',
      sortKey: 'createdDate',
      title: aciHighwayManifestTranslationText.creationdatetime,
      render: (data) =>
        data.createdDate && moment(data.createdDate).tz("Canada/Eastern").format('D MMM YYYY, HH:mm')
    },
    {
      field: 'submittedDate',
      sortKey: 'submittedDate',
      title: aciHighwayManifestTranslationText.submittedDate,
      render: (data) => data.submittedDate && moment(data.submittedDate).tz("Canada/Eastern").format('D MMM YYYY, HH:mm')
    }
  ]

  let challengerColumns = [
    {
      field: 'apiAutoSubmit',
      sortKey: 'reviewStatus',
      title: aciHighwayManifestTranslationText.reviewStatus,
      render: (data) => {
        if (data.apiAutoSubmit) {
          const reviewStatus = getStatusMetadata(data.apiAutoSubmit)

          return (
            <>
              <Chip
                label={reviewStatus.label}
                size='small'
                style={{
                  backgroundColor: reviewStatus.color,
                  color: reviewStatus.contrastColor
                }}
              />
            </>
          )
        }
      }
    }
  ]

  if (whiteLabelServiceSettings && whiteLabelServiceSettings.length > 0
    && whiteLabelServiceSettings[0].custom.UI_MANIFEST_CARGO_TABLE_REVIEW_STATUS === 'true') {
    columns = [...columns, ...challengerColumns]
  }

  const filters = [
    {
      label: aciHighwayManifestTranslationText.tripNum,
      type: 'textfield',
      name: 'tripNum',
      operatorType: LIKE
    },
    {
      label: aciHighwayManifestTranslationText.expArrivalDate,
      type: 'daterange',
      name: 'expArrivalDate',
      operatorType: BETWEEN
    },
    {
      label: aciHighwayManifestTranslationText.followUpStatus,
      type: 'radio',
      name: 'firstCargoInfo',
      operatorType: EQUAL,
      options: [
        { label: 'Pending Entry Number', value: 'yellow', filterValue: { value: 'yellow' } },
        { label: aciHighwayManifestTranslationText.portMismatch, value: 'red', filterValue: { value: 'red' } }
      ]
    },
    {
      label: aciHighwayManifestTranslationText.driver,
      type: 'textfield',
      name: 'fullName',
      operatorType: LIKE
    },
    {
      label: aciHighwayManifestTranslationText.truck,
      type: 'textfield',
      name: 'conveyanceNum',
      operatorType: LIKE
    },
    {
      label: aciHighwayManifestTranslationText.trailer,
      type: 'textfield',
      name: 'equipmentNo',
      operatorType: LIKE
    },
    {
      label: aciHighwayManifestTranslationText.firstExpectedPort,
      type: 'textfield',
      name: 'firstExpectedPort',
      operatorType: LIKE
    },
    {
      label: aciHighwayManifestTranslationText.creationdatetime,
      type: 'daterange',
      name: 'createdDate',
      operatorType: BETWEEN
    },
    {
      label: 'Last Modified Date',
      type: 'daterange',
      name: 'submittedDate',
      operatorType: BETWEEN
    },
    {
      label: aciHighwayManifestTranslationText.status,
      type: 'checkbox',
      name: 'status',
      operatorType: IN,
      options: [
        {
          label: aciHighwayManifestTranslationText.draftStatus,
          value: 'draft',
          filterValue: {
            value: '1005'
          }
        },
        {
          label: aciHighwayManifestTranslationText.acceptedStatus,
          value: 'accepted',
          filterValue: {
            value: '1000'
          }
        },
        {
          label: aciHighwayManifestTranslationText.sentStatus,
          value: 'sent',
          filterValue: {
            value: '1008'
          }
        },
        {
          label: aciHighwayManifestTranslationText.rejectedStatus,
          value: 'rejected',
          filterValue: {
            value: '1001'
          }
        },
        /*{
          label: 'Template',
          value: 'Template',
          filterValue: {
            value: '1002'
          }
        },*/
        {
          label: aciHighwayManifestTranslationText.statusNotificationStatus,
          value: 'status_notification',
          filterValue: {
            value: '1006'
          }
        },
        {
          label: aciHighwayManifestTranslationText.cancellationAcceptedStatus,
          value: 'cancellation_accepted',
          filterValue: {
            value: '1003'
          }
        },
        {
          label: aciHighwayManifestTranslationText.cancellationRejectedStatus,
          value: 'cancellation_rejected',
          filterValue: {
            value: '1004'
          }
        },
        {
          label: aciHighwayManifestTranslationText.modificationRejectedStatus,
          value: 'modification_rejected',
          filterValue: {
            value: '1007'
          }
        },
        {
          label: aciHighwayManifestTranslationText.truckArrivedStatus,
          value: 'truck_arrived',
          filterValue: {
            value: '1024'
          }
        },
        {
          label: aciHighwayManifestTranslationText.goodsReleasedStatus,
          value: 'goods_released',
          filterValue: {
            value: '1025'
          }
        }
      ]
    },
    {
      label: aciHighwayManifestTranslationText.reviewStatus,
      type: 'checkbox',
      name: 'apiAutoSubmit',
      operatorType: IN,
      options: [
        {
          fullWidth: true,
          label: aciHighwayManifestTranslationText.pendingReview,
          value: 'pending_review',
          filterValue: {
            value: 'R'
          }
        },
        {
          fullWidth: true,
          label: aciHighwayManifestTranslationText.reviewInProgress,
          value: 'review_in_progress',
          filterValue: {
            value: 'Y'
          }
        },
        {
          fullWidth: true,
          label: aciHighwayManifestTranslationText.reviewed,
          value: 'reviewed',
          filterValue: {
            value: 'G'
          }
        }
      ]
    }
  ]

  function handleCloneManifest(data) {
    data.cloneFrom = data.tripNum;
    createRecord.execute(
      AciHighwayManifestApiUrls.CLONE,
      data,
      (data) => {
        const trailerData = data.trailerDTO.map(
          (trailerDTO, index) => ({ ...trailerDTO, _id: index + 1 })
        )
        data.trailerDTO = trailerData

        const personData = data.personDTO.map(
          (personDTO, index) => ({
            ...personDTO, _id: index + 1,
            personDocumentDTO: personDTO.personDocumentDTO.map((documentDTO, documentIndex) => ({
              ...documentDTO,
              _id: documentIndex + 1,
              _personDTOId: index,
              expiryDate: documentDTO.expiryDate ? moment(documentDTO.expiryDate).format('YYYY-MM-DD') : ""
            })),
          })
        )
        data.personDTO = personData
        data.expArrivalTime = moment(data.expArrivalDate).format('HH:mm');
        data.expArrivalDate = moment(data.expArrivalDate).format('YYYY-MM-DD');

        history.push(pathMap.ACIHWY_MANIFEST_ADD_VIEW, data)
      },
      (error) => {
        console.log(error)
      }
    )
  }

  function handleDeleteManifest() {
    if (confirmDialog.manifest) {
      setLoading(true)
      securedSendRequest.execute(
        'DELETE',
        AciHighwayManifestApiUrls.DELETE,
        confirmDialog.manifest,
        (response) => {
          if (response.status === 200) {
            showNotification('success', aciHighwayManifestTranslationText.deleteSucceeded)
            setConfirmDialog({ open: false, manifest: null })
            setManifestTemplateDialog(false)
            tableRef.current.performRefresh()
          }
        },
        (error) => {
          let  errorResponse = error.response;
          if(errorResponse.status == 403){
             
            if(errorResponse.data){
              
              showNotification('error', errorResponse.data.errorMessages)
              
            }
          }
          console.log(error)
        },
        ()=>{
          setLoading(false)
        },
        {},
        null
      )
    }
  }

  function preCancel(data) {
    if (isSuperParty || (null != user.corpid && undefined != user.corpid && user.corpid.length > 0 && user.corpid[0].serviceBureauFlag)) {
      setSubmitDialog({ open: true, items: data })
    } else {
      data.chargeAs = 'REGULAR'
      handleCancelManifest(data)
    }
  }

  async function handleCancelManifest(data) {
    let chargeTypes = data.chargeAs
    let fileForUserDetails = FileForUserGetUserDetails();
    if (fileForUserDetails != null && fileForUserDetails != undefined) {
      data.fileForUserId = fileForUserDetails.fileForUserId;
      data.fileForUserLoginId = fileForUserDetails.fileForUserLoginId;
      data.fileForUserPartyId = fileForUserDetails.fileForUserPartyId;
    }

    tableRef.current.setLoading(true)
    const instance = axios.create({
      withCredentials: false,
      headers: {
        Authorization:
          'Bearer ' + JSON.parse(localStorage.getItem('userToken')),
        'Content-Type': 'application/json'
      }
    })

    const response = await fetchRecords.execute(
      AciHighwayCargoApiUrls.GET,
      {
        filters: [{
          field: 'manifestId',
          operator: EQUAL,
          value: data.id
        }, {
          field: 'status',
          operator: IN,
          value: ['1000', '1007', '1004']
        }]
      },
      (data) => data.content)
    const cargos = [...response]

    if (cargos.length > 0) {
      console.log("cargos :", cargos)
      cargos.forEach(cargo => {
        if (fileForUserDetails != null && fileForUserDetails != undefined) {
          cargo.fileForUserId = fileForUserDetails.fileForUserId;
          cargo.fileForUserLoginId = fileForUserDetails.fileForUserLoginId;
          cargo.fileForUserPartyId = fileForUserDetails.fileForUserPartyId;
        }
        cargo.messageFunction = '03'
        cargo.deleteFromManifest = 'Y'
        cargo.chargeAs = chargeTypes
      })

      instance
        .post(AciHighwayManifestApiUrls.SUBMIT_ALL, JSON.stringify(cargos))
        .then(
          (result) => {
            var returnData = result.data
            var errorMessages = returnData.errorMessages
            if (
              result.status == 200 &&
              returnData != null &&
              errorMessages == null
            ) {
              showNotification('success', aciHighwayManifestTranslationText.manifestCancelledMsg)
              tableRef.current.performRefresh();
            } else {
              showNotification('error', errorMessages)
            }
          },
          (error) => console.log(error),
          () => tableRef.current.setLoading(false)
        )
    } else {
      console.log("empty cargos :", cargos)
      data.messageFunction = '03'
      instance
        .post(AciHighwayManifestApiUrls.SUBMIT, JSON.stringify(data))
        .then(
          (result) => {
            var returnData = result.data
            var errorMessages = returnData.errorMessages
            console.log("result.status: " + result.status);
            console.log("returnData: " + returnData);
            console.log("errorMessages: " + errorMessages);
            if (
              result.status == 200 &&
              returnData != null &&
              errorMessages == null
            ) {
              showNotification('success', aciHighwayManifestTranslationText.manifestCancelSentMsg)
              tableRef.current.performRefresh();
            } else {
              showNotification('error', errorMessages)
            }
          },
          (error) => { console.log("error: " + JSON.stringify(error)); showNotification('error', aciHighwayManifestTranslationText.errorOccured); tableRef.current.setLoading(false) },
          () => tableRef.current.setLoading(false)
        )
    }

  }

  function handlePrintCoverSheet(data) {
    const config = { responseType: 'blob' }

    let fileForUserDetails = FileForUserGetUserDetails();
    if (fileForUserDetails != null && fileForUserDetails != undefined) {
      data.fileForUserId = fileForUserDetails.fileForUserId;
      data.fileForUserLoginId = fileForUserDetails.fileForUserLoginId;
      data.fileForUserPartyId = fileForUserDetails.fileForUserPartyId;
    }

    securedSendRequest.execute(
      'POST',
      AciHighwayManifestApiUrls.PRINTCOVERSHEET,
      data,
      (response) => {
        let blob = new Blob([response.data])

        let first = 'ACI_HW_COVER'
        let curDate = format(new Date(), 'yyyyMMddHHmmss')
        let filename = first + curDate + '.pdf'
        let url = window.URL.createObjectURL(blob)
        let a = document.createElement('a')
        a.href = url
        a.download = filename
        a.click()
      },
      (error) => console.error(error),
      undefined,
      config,
      null
    )
  }

  function handlePrintD4(dataD4) {
    console.log("Inside d4 print " + dataD4);
    const config = { responseType: 'blob' }

    let fileForUserDetails = FileForUserGetUserDetails();
    if (fileForUserDetails != null && fileForUserDetails != undefined) {
      dataD4.fileForUserId = fileForUserDetails.fileForUserId;
      dataD4.fileForUserLoginId = fileForUserDetails.fileForUserLoginId;
      dataD4.fileForUserPartyId = fileForUserDetails.fileForUserPartyId;
    }

    securedSendRequest.execute(
      'POST',
      AciHighwayManifestApiUrls.PRINTD4,
      dataD4,
      (response) => {
        let blob = new Blob([response.dataD4])

        let first = 'ACI_HW_D4_'
        let curDate = format(new Date(), 'yyyyMMddHHmmss')
        let filename = first + curDate + '.pdf'
        let url = window.URL.createObjectURL(blob)
        let a = document.createElement('a')
        a.href = url
        a.download = filename
        a.click()
      },
      (error) => console.error(error),
      undefined,
      config,
      null
    )
  }

  async function exportManifest(data) {
    if (data.length > 0) {
      const config = { responseType: 'blob' }
      console.log(data);

      securedSendRequest.execute('POST', AciHighwayManifestApiUrls.EXPORT_MANIFEST, data,
        (response) => {
          let blob = new Blob([response.data])

          let first = 'ACIHW_MANIFEST_EXPORT_'
          let curDate = format(new Date(), 'yyyyMMddHHmmss')
          let filename = first + curDate + '.csv'
          let url = window.URL.createObjectURL(blob)
          let a = document.createElement('a')
          a.href = url
          a.download = filename
          a.click()
        },
        (error) => console.error(error),
        undefined,
        config,
        null
      )
    }
  }

  function handleMassDeleteManifest() {
    if (massDeleteConfirmDialog.idList) {
      setMassDeleteConfirmDialog({ open: false })
      sweetalert(aciHighwayManifestTranslationText.manifestDeleteInProgressMsg, "", "success");
      securedSendRequest.execute('POST',
        AciHighwayManifestApiUrls.MASS_DELETE,
        massDeleteConfirmDialog.idList,
        () => {
          showNotification('success', aciHighwayManifestTranslationText.massDeleteSucceedMsg)
          setMassDeleteConfirmDialog({ open: false, idList: null })
          tableRef.current.performRefresh()
        },
        (error) => {
          showNotification('error', aciHighwayManifestTranslationText.massDeleteErrorMsg + ' - ' + aciHighwayManifestTranslationText.errorOccured)
          console.log(error)
        }
      )
    }
  }

  return (
    <>
      <Table
        actions={[
          {
            buttonProps: {
              color: 'primary',
              size: 'medium',
              startIcon: <FontAwesomeIcon icon={['fal', 'plus-circle']} />,
              onClick: () => history.push(pathMap.ACIHWY_MANIFEST_ADD_VIEW)
            },
            label: aciHighwayManifestTranslationText.createManifest
          },
          {
            buttonProps: {
              color: 'primary',
              size: 'medium',
              startIcon: <FontAwesomeIcon icon={['fal', 'plus-circle']} />,
              onClick: () => setManifestTemplateDialog(true)
            },
            label: aciHighwayManifestTranslationText.manifestTemplate
          }
        ]}
        columns={columns}
        compact
        exportData={{ url: AciHighwayManifestApiUrls.CUSTOM_EXPORT }}
        fetch={{ url: AciHighwayManifestApiUrls.CUSTOM_SEARCH }}
        fetchFilters={[
          { field: 'templateFlag', operator: EQUAL, value: '0' },
          { field: 'partyId', operator: EQUAL, value: FileForUserGetPartyId() }
        ]}
        filters={filters}
        onRowClick={(rowData) => {
          if (rowData.status === '1008') {
            history.push(`${location.pathname}/view/${rowData.id}`)
          }
          else {
            history.push(`${location.pathname}/edit/${rowData.id}`)
          }
        }}
        rowActions={[
          {
            disabled: (rowData) => rowData.status === '1008',
            icon: <FontAwesomeIcon icon={['fal', 'pen']} />,
            label: aciHighwayManifestTranslationText.editButton,
            onClick: (rowData) =>
              history.push(`${location.pathname}/edit/${rowData.id}`),
            tooltip: (rowData) =>
              rowData.status === '1008'
                ? aciHighwayManifestTranslationText.editSentRecords
                : null
          },
          {
            icon: <FontAwesomeIcon icon={['fal', 'copy']} />,
            label: aciHighwayManifestTranslationText.cloneButton,
            onClick: handleCloneManifest
          },
          {
            disabled: (data) => {
              return data.status !== '1000'
            },
            label: aciHighwayManifestTranslationText.cancelButton,
            icon: <FontAwesomeIcon icon={['fal', 'ban']} />,
            onClick: preCancel,
            tooltip: (rowData) =>
              rowData.status !== '1000'
                ? aciHighwayManifestTranslationText.cancelMultipleRecords
                : null
          },
          {
            disabled: (data) => data.status !== '1005',
            label: aciHighwayManifestTranslationText.deleteButton,
            icon: <FontAwesomeIcon icon={['fal', 'trash']} />,
            onClick: (data) => setConfirmDialog({ open: true, manifest: data })
          },
          {
            label: aciHighwayManifestTranslationText.printCoverSheet,
            icon: <FontAwesomeIcon icon={['fal', 'print']} />,
            onClick: handlePrintCoverSheet
          },
          // {
          //   label: aciHighwayManifestTranslationText.d4,
          //   icon: <FontAwesomeIcon icon={['fal', 'print']} />,
          //   onClick: handlePrintD4
          // },
          {
            icon: <FontAwesomeIcon icon={['fal', 'envelope']} />,
            label: aciHighwayManifestTranslationText.emailCoverSheet,
            onClick: (rowData) => setEmailCoverSheetDialog({ open: true, data: rowData }),
          },
          {
            icon: <FontAwesomeIcon icon={['fal', 'fax']} />,
            label: aciHighwayManifestTranslationText.faxCoverSheet,
            onClick: (rowData) => setFaxCoverSheetDialog({ open: true, data: rowData }),
          }
        ]}
        showNotification={showNotification}
        sortConfig={{
          type: 'column',
          defaultField: 'createdDate',
          defaultDirection: 'DESC'
        }}
        persistSettings
        tableRef={tableRef}
        checkboxSelection
        tablePreference={{ module: 'ACIHWY', key: 'manifest_table_visible_column' }}
        selectActions={[
          {
            // disabled: (rows) => rows.length > 100,
            icon: <FontAwesomeIcon icon={['fal', 'link']} />,
            label: "Export Manifest(s)",
            onClick: (rows) => {
              if (rows.length > 100) {
                sweetalert(aciHighwayManifestTranslationText.exportMax100, "", "error");
              } else {
                sweetalert(aciHighwayManifestTranslationText.exportManifestInBackground, "", "success");
                return exportManifest(rows);
              }
            },
            tooltip: (rows) => rows.length > 100 ? aciHighwayManifestTranslationText.exportMax100 : null

          },
          {
            disabled: (rows) => {
              let disable = false;
              rows.forEach(e => {
                if (e.status !== '1005') { disable = true }
              })
              return disable;
            },
            icon: <FontAwesomeIcon icon={['fal', 'trash']} />,
            label: "Mass Delete",
            tooltip: (rows) => {
              let description = null;
              rows.forEach(e => {
                if (e.status !== '1005') { description = aciHighwayManifestTranslationText.onlyDraftCanBeDeleted }
              })
              return description;
            },
            buttonProps: {
              size: 'medium',
              color: 'secondary',
              style: { color: theme.palette.error.main, minWidth: 'auto' }
            },
            onClick: (rows) => {
              let idList = rows.map(e => e.id)
              setMassDeleteConfirmDialog({ open: true, idList: idList });
            }
          }
        ]}
      />
      <QuickGlanceShipmentDialog
        getLookupValue={getLookupValue}
        manifest={quickGlanceShipmentDialog.manifest}
        onClose={() => setQuickGlanceShipmentDialog({ open: false, manifest: null })}
        open={quickGlanceShipmentDialog.open}
        aciHighwayManifestTranslationText={aciHighwayManifestTranslationText}
      />

      <QuickGlanceResponseLogDialog
        getLookupValue={getLookupValue}
        manifest={quickGlanceResponseLogDialog.manifest}
        onClose={() => setQuickGlanceResponseLogDialog({ open: false, manifest: null })}
        open={quickGlanceResponseLogDialog.open}
        aciHighwayManifestTranslationText={aciHighwayManifestTranslationText}
      />
      <TemplateSelectDialogWithOptionACIHWY
        manifestTemplateDialog={manifestTemplateDialog}
        setManifestTemplateDialog={setManifestTemplateDialog}
        setConfirmDialog={setConfirmDialog}
        showNotification={showNotification}
        aciHighwayManifestTranslationText={aciHighwayManifestTranslationText}
        isTable={true}
        location={location}
        rowActions={[
          {
            icon: <FontAwesomeIcon icon={['fal', 'pen']} />,
            label: aciHighwayManifestTranslationText.editButton,
            onClick: (rowData) =>
              history.push(pathMap.ACIHWY_MANIFEST + `/edit/${rowData.id}`),
            tooltip: () => aciHighwayManifestTranslationText.editButton.toLocaleLowerCase
          },
          {
            icon: <FontAwesomeIcon icon={['fal', 'trash']} />,
            label: aciHighwayManifestTranslationText.deleteButton,
            onClick: (rowData) =>
              setConfirmDialog({ open: true, manifest: rowData }),
            tooltip: () => aciHighwayManifestTranslationText.deleteButton.toLocaleLowerCase
          }
        ]}
      />
      <ConfirmDialogShowProgress
        isConfirmDialogOpen={confirmDialog.open}
        closeDialog={() => setConfirmDialog({ open: false, manifest: null })}
        confirmDialog={handleDeleteManifest}
        content={aciHighwayManifestTranslationText.deleteWarningMessage}
        okMsg={aciHighwayManifestTranslationText.okDeleteButton}
        cancelMsg={aciHighwayManifestTranslationText.cancelDeleteButton}
        title={aciHighwayManifestTranslationText.deleteButton}
        isSubmitting={loading}
      />
      <NoteFlagDialog
        openDialog={noteFlagDialog}
        manifestId={manifestId}
        onClose={() => setNoteFlagDialog({ open: false, manifest: null })}
        showNotification={showNotification}
        tableRef={tableRef}
      />
      <EmailCoverSheetDialog
        openDialog={emailCoverSheetDialog}
        onClose={() => setEmailCoverSheetDialog({ open: false, data: null })}
        showNotification={showNotification}
      />
      <FaxCoverSheetDialog
        openDialog={faxCoverSheetDialog}
        onClose={() => setFaxCoverSheetDialog({ open: false, data: null })}
        showNotification={showNotification}
      />
      <ChargeTypeDialog
        chargeTypes={chargeTypes}
        onClose={() => setSubmitDialog({ open: false, items: [] })}
        onSubmit={(data) => {
          handleCancelManifest(data)
        }}
        open={submitDialog.open}
        items={submitDialog.items}
      />
      <ConfirmDialog
        isConfirmDialogOpen={massDeleteConfirmDialog.open}
        closeDialog={() => setMassDeleteConfirmDialog({ open: false, idList: null })}
        confirmDialog={handleMassDeleteManifest}
        content={aciHighwayManifestTranslationText.deleteItemConfirmMsg}
        okMsg={aciHighwayManifestTranslationText.okDeleteButton}
        cancelMsg={aciHighwayManifestTranslationText.cancelDeleteButton}
        title={aciHighwayManifestTranslationText.deleteButton}
      />
    </>
  )
}

export default TablePage

function QuickGlanceShipmentDialog(props) {

  const { getLookupValue, manifest, onClose, open, aciHighwayManifestTranslationText } = props
  const { securedSendRequest } = useServices()
  const theme = useTheme()
  const [statusList, setStatusList] = useState([])
  const [redirectUrl, setRedirectUrl] = useState()

  const redirectData = {
    manifestData: { ...manifest },
    step: "2"
  }

  useEffect(() => {

    //reset status
    setStatusList([])
    if (manifest != null && manifest != undefined && open) {
      if (manifest.status != null && manifest.status != undefined && manifest.status == "1008") {
        setRedirectUrl("/aci-highway/manifest/view/" + manifest.id)
      } else {
        setRedirectUrl("/aci-highway/manifest/edit/" + manifest.id)
      }


      const formData = new FormData();
      formData.append('manifestId', manifest.id);

      let config = {}

      securedSendRequest.execute(
        'POST',
        AciHighwayCargoApiUrls.GET_COUNT_BY_STATUS,
        formData,
        (response) => {
          console.log(response)
          let data = response.data
          if (data != null && data != undefined && data.length > 0) {
            var result = data.reduce(function (map, obj) {
              map[obj.STATUS] = obj.TOTAL;
              return map;
            }, {});
            setStatusList(data)
          }
        },
        (error) => console.error(error),
        undefined,
        config,
        null
      )
    }
  }, [open]);

  let content = manifest ? (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Card variant='outlined'>
          <Box px={2} py={1}>
            <Grid container justify='space-between' spacing={2}>
              <Grid item xs={12} sm='auto'>
                <Typography variant='h6' style={{ fontWeight: 700 }}>
                  {aciHighwayManifestTranslationText.totalNoOfCargo}
                </Typography>
              </Grid>
              <Grid item xs={12} sm='auto'>
                <Typography variant='body2'>
                  <Typography
                    color='textSecondary'
                    component='span'
                    variant='inherit'
                    style={{ fontWeight: 700 }}
                  >
                    {aciHighwayManifestTranslationText.scac} &amp; {aciHighwayManifestTranslationText.tripNum}:&nbsp;
                  </Typography>
                  <Typography component='span' variant='inherit' style={{ fontWeight: 700 }}>
                    {manifest.tripNum}
                  </Typography>
                </Typography>
              </Grid>
            </Grid>
          </Box>
          <Box px={2} py={1} style={{ backgroundColor: theme.palette.background.sectionOddBg }}>
            <Grid container flexWrap='wrap' spacing={2}>
              {statusList.map((data) => {
                const statusData = getStatusMetadata(data.STATUS)
                return (
                  <Grid item xs='auto'>
                    <Typography variant='body2' style={{ fontWeight: 700 }}>
                      {statusData.label}&nbsp;
                      <Typography
                        color='primary'
                        component='span'
                        variant='inherit'
                      >
                        {data.TOTAL}
                      </Typography>
                    </Typography>
                  </Grid>
                )
              })}
            </Grid>
          </Box>
        </Card>
      </Grid>
      <Grid item xs={12}>
        <CngSection
          title={
            <Box display='flex' alignItems='baseline' style={{ gap: 4 }}>
              <Typography style={{ fontWeight: 600 }}>
                {aciHighwayManifestTranslationText.cargo}
              </Typography>
              <Typography color='textSecondary' variant='caption'>
                {/*`/ ${manifest.shipmentInfo.length} Entries`*/}
              </Typography>
            </Box>
          }
        >
          <CargoTable
            disableView
            getLookupValue={getLookupValue}
            manifestId={manifest.id}
            manifestPort={manifest.firstExpectedPort}
            noOfCargo={manifest.noOfCargo}
            redirectUrl={redirectUrl}
            redirectData={redirectData}
            additionalButtonLabel={aciHighwayManifestTranslationText.additionalCargo}
          />
        </CngSection>
      </Grid>
    </Grid>
  ) : null

  return (
    <CngDialog
      dialogContent={content}
      dialogAction={<CngButton onClick={onClose}>{aciHighwayManifestTranslationText.okayButton}</CngButton>}
      dialogTitle={aciHighwayManifestTranslationText.quickGlanceTitle}
      fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
      fullWidth
      maxWidth='lg'
      onClose={onClose}
      open={open}
      shouldShowCloseButton
    />
  )
}

function QuickGlanceResponseLogDialog(props) {
  const { getLookupValue, manifest, onClose, open, aciHighwayManifestTranslationText } = props
  const { securedSendRequest } = useServices()
  const theme = useTheme()
  const [statusList, setStatusList] = useState([])
  const [redirectUrl, setRedirectUrl] = useState()
  
  const redirectData = {
    manifestData: { ...manifest },
    step: "2"
  }

  let content = manifest ? (
    <Grid item xs={12}>
      <ResponseLog
        disableView
        getLookupValue={getLookupValue}
        manifestId={manifest.id}
        manifestPort={manifest.firstExpectedPort}
        noOfShipment={manifest.noOfShipment}
        redirectUrl={redirectUrl}
        redirectData={redirectData}
        additionalButtonLabel={aciHighwayManifestTranslationText.additionalShipment}
      />
    </Grid>
  ) : null
  return (
    <CngDialog
      dialogContent={content}
      dialogAction={<CngButton onClick={onClose}>OK</CngButton>}
      dialogTitle={aciHighwayManifestTranslationText.responseLogTitle}
      fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
      fullWidth
      maxWidth='lg'
      onClose={onClose}
      open={open}
      shouldShowCloseButton
    />
  )
}